import React, { Component } from "react";
import { Button, Header, Segment, Grid } from "semantic-ui-react";
import isUrl from "is-url";
import GraderApi from "../utils/GraderApi";

const QUESTIONS = null;
GraderApi.get_applicant_feather_map()
  .then((response) => {
    QUESTIONS = response.data;
  })
  .catch((response) => {
    console.log(response);
    console.log("COULD NOT RETRIVE APPLICATION CONFIG");
  });

var questions = [
  {
    question: "First Name",
    label: "first_name",
  },
  {
    question: "Last Name",
    label: "last_name",
  },
  {
    question: "Email",
    label: "email",
  },
  {
    question: "School",
    label: "school",
  },
];

class AppHeader extends Component {
  constructor(props) {
    super(props);
  }

  addBullets(label, values) {
    let learn = JSON.parse(values);
    let bullets = learn.map((item) => <div>{item}</div>);
    return (
      <Grid.Column>
        <Grid.Row>
          <p style={{ textAlign: "center" }}>
            <b>{label}</b>: {bullets}
          </p>
        </Grid.Row>
      </Grid.Column>
    );
  }

  processItem(item, config) {
    console.log("processing item", item, config);
    switch (config.type) {
      case "text":
        return (
          <p style={{ textAlign: "center" }}>
            <b>{config.label}</b>: {item}
          </p>
        );
      case "multiple":
        return this.addBullets(config.label, item);
    }
    return null;
  }

  render() {
    if (!this.props.app || !this.props.app.profile) {
      return <Header>No Profile Header Found!</Header>;
    }
    let info = Object.entries(this.props.app.profile).map(([key, item], i) => (
      <Grid.Column key={i}>
        <Grid.Row>
          <Grid.Column>
            <Grid.Row>
              <p style={{ textAlign: "center" }}>
                <b>{key}</b>: {item}
              </p>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>
      </Grid.Column>
    ));
    return (
      <Segment padded style={{ marginTop: 0 }}>
        <Header textAlign="center">
          Applicant UID: {this.props.app.profile.uid}{" "}
          {/* {this.props.app.profile.last_name} */}
        </Header>
        <br />
      <Grid padded columns={2}>
        {/* {info}  */}
        {/* remove affiliation, company */}
      </Grid>
      </Segment>
    );
  }
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/grader/AppHeader.js